import { FullScreenModal } from "src/Shared/Components";
import { observer } from "mobx-react";
import { useModal } from "src/Shared/Hooks";
import ActionAssignedByUserGrid from "src/Modules/MyActions/Components/ActionAssignedByUserGrid/ActionAssignedByUserGrid";
import { Button } from "@mui/material";
import { VIEW_MODE } from "src/Shared/Enums/ViewMode.enum";
import AddOrEditAction from "../AddOrEditAction/AddOrEditAction";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SalesAction from "../SalesAction/SalesAction";

type Props = {
    companyRowID: string;
};
const ViewSLAActions: React.FC<Props> = ({ companyRowID }) => {
    const modal = useModal();
    const addNewAction = () => {
        modal.open(
            <AddOrEditAction mode={VIEW_MODE.ADD} companyRowID={"companyRowID"} />
        );
    };

    return (
        <>
            <div>
                <Button variant="contained" onClick={addNewAction}>
                    <AddCircleIcon />
                    Add Action
                </Button>
            </div>
            <FullScreenModal title="SLA Actions">
                <SalesAction companyRowID={companyRowID} />
            </FullScreenModal>
        </>
    );
};

export default observer(ViewSLAActions);